import axios from "axios";
import {URL, empowerment_all, income_act, return_act, roaming_document, supplier_all} from './api'

axios.defaults.baseURL = URL
axios.defaults.withCredentials = true;

// axios.interceptors.request.use(
//     (config) => {
//         const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3ODcyODQyNjEsImlkIjoyLCJvcmlnX2lhdCI6MTc4NzIxOTQ2MX0.bU6R1i3uIy8MbpS7LhIq98tpREt3CsYMfPq5Mwy3aPY"
//         if (token) {
//             config.headers['Authorization'] = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

export const getRequest = ({url, params}) => axios.get(url, {params}).then(res => res.data)

// Every one of these list families is scoped to the current organization on the
// backend, so their SWR keys go stale whenever the current organization changes.
const ORGANIZATION_SCOPED_PREFIXES = [income_act, return_act, supplier_all, roaming_document, empowerment_all]
    .map(i => i.replace(/\/all$/, ''))

export const isOrganizationScopedKey = (key) => !!key && typeof key === 'object'
    && ORGANIZATION_SCOPED_PREFIXES.some(prefix => key.url?.startsWith(prefix))


export const postRequest = (url, {arg}) => axios.post(url, arg.data, {params: arg.params}).then(res => res.data)


export const triggerAxios = (url, {arg}) => axios(arg?.url || url, {
    ...arg,
    method: arg.method || "GET",
    params: arg.params,
    data: arg.data,
}).then(res => res.data)

export const afterRequest = (
    trigger,
    data = {},
    success = () => null,
    error = () => null,
    final = () => null
) => {
    trigger(data).then(res => success(res)).catch(err => error(err)).finally(() => final())
}